import React from 'react';
import { Square, UtensilsCrossed, Bath } from 'lucide-react';
import { StepButtons } from '../ui';

interface KeyElementsStepProps {
  value: {
    keyElements: {
      windows: boolean;
      kitchen: boolean;
      bathroom: boolean;
    };
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const KeyElementsStep: React.FC<KeyElementsStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleElementToggle = (element: keyof typeof value.keyElements) => {
    onChange('keyElements', {
      ...value.keyElements,
      [element]: !value.keyElements[element]
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-primary">Éléments à rénover</h2>
      
      <div className="grid grid-cols-3 gap-4">
        <ElementCard
          icon={<Square className="h-8 w-8" />}
          label="Fenêtres"
          description="À remplacer"
          selected={value.keyElements.windows}
          onClick={() => handleElementToggle('windows')}
        />
        <ElementCard
          icon={<UtensilsCrossed className="h-8 w-8" />}
          label="Cuisine"
          description="À rénover"
          selected={value.keyElements.kitchen}
          onClick={() => handleElementToggle('kitchen')}
        />
        <ElementCard
          icon={<Bath className="h-8 w-8" />}
          label="Salle de bain"
          description="À refaire"
          selected={value.keyElements.bathroom}
          onClick={() => handleElementToggle('bathroom')}
        />
      </div>

      <StepButtons
        onNext={onNext}
        onBack={onBack}
      />
    </div>
  );
};

interface ElementCardProps {
  icon: React.ReactNode;
  label: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}

const ElementCard: React.FC<ElementCardProps> = ({
  icon,
  label,
  description,
  selected,
  onClick
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      card flex flex-col items-center p-6 transition-all
      ${selected ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
    `}
  >
    <div className={`mb-4 ${selected ? 'text-primary' : 'text-neutral-600'}`}>
      {icon}
    </div>
    <span className={`font-medium mb-2 ${selected ? 'text-primary' : 'text-neutral-700'}`}>
      {label}
    </span>
    <p className="text-sm text-neutral-500 text-center">
      {description}
    </p>
  </button>
);

export default KeyElementsStep;